// extracted by mini-css-extract-plugin
module.exports = {"SingleCardAdjustment":"SingleListCardContainer_SingleCardAdjustment__1bDFo"};